import React from 'react'
import useApi from 'hooks/useApi'
import DocsPage from 'components/DocumentationPage'
import { FormattedMessage, useIntl } from 'react-intl'
import messages from './messages'

const DocumentationPage = ({ history, match }) => {
  const [docs, loading] = useApi('/rest/v2/customer/docs')

  return (
    <DocsPage
      loading={loading}
      docs={docs}
      title={<FormattedMessage {...messages.training} />}
      subtitle={<FormattedMessage {...messages.exploreFeatures} />}
      match={match}
    />
  )
}

export default DocumentationPage
